// ============================================================
// Fee Structures API
// ============================================================

import client from './axios';

export const feeStructuresApi = {
  /**
   * Get list of fee structures for a school
   */
  getFeeStructures: async (schoolId, skip = 0, limit = 100) => {
    const response = await client.get('/fee-structures', {
      params: {
        school_id: schoolId,
        skip,
        limit,
      },
    });
    return response.data;
  },

  /**
   * Get single fee structure by ID
   */
  getFeeStructureById: async (schoolId, id) => {
    const response = await client.get(`/fee-structures/${id}`, {
      params: {
        school_id: schoolId,
      },
    });
    return response.data;
  },

  /**
   * Create a new fee structure
   */
  createFeeStructure: async (schoolId, payload) => {
    const response = await client.post('/fee-structures', payload, {
      params: {
        school_id: schoolId,
      },
    });
    return response.data;
  },

  /**
   * Update an existing fee structure
   */
  updateFeeStructure: async (schoolId, id, payload) => {
    const response = await client.put(`/fee-structures/${id}`, payload, {
      params: {
        school_id: schoolId,
      },
    });
    return response.data;
  },

  /**
   * Delete a fee structure by ID
   */
  deleteFeeStructure: async (schoolId, id) => {
    const response = await client.delete(`/fee-structures/${id}`, {
      params: {
        school_id: schoolId,
      },
    });
    return response.data;
  },
};
